import { render, staticRenderFns } from "./AddNurse.vue?vue&type=template&id=3e083704&scoped=true&"
import script from "./AddNurse.vue?vue&type=script&lang=js&"
export * from "./AddNurse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e083704",
  null
  
)

export default component.exports